import { useEffect, useState } from "react";

// 📱 Écran de téléphone (tour 49) : même seuil que les styles du nouveau design
// (@media (max-width: 575.98px)). Tablette et ordinateur au-dessus. Sans matchMedia : ordinateur.
export const PHONE_QUERY = "(max-width: 575.98px)";

export const isPhoneScreen = () => {
  try {
    return typeof window !== "undefined" && !!window.matchMedia?.(PHONE_QUERY)?.matches;
  } catch (e) {
    return false;
  }
};

// Suit les changements de largeur (rotation, fenêtre redimensionnée)
export const usePhoneScreen = () => {
  const [phone, setPhone] = useState(isPhoneScreen);
  useEffect(() => {
    let query = null;
    try {
      query = window.matchMedia?.(PHONE_QUERY) || null;
    } catch (e) {
      query = null;
    }
    if (!query?.addEventListener) return undefined;
    const update = () => setPhone(!!query.matches);
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);
  return phone;
};
